// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rule_rule__dGgPV {
  padding-top: 20px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 180px;
  height: 100%;
}
.Rule_rule__dGgPV .Rule_img__VL\\+9D {
  display: flex;
  justify-content: center;
}
.Rule_rule__dGgPV .Rule_title__mPmJN {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 16px;
}
.Rule_rule__dGgPV .Rule_txt__ZjHwb {
  font-weight: 400;
  font-size: 18px;
  line-height: 131%;
  text-align: center;
  color: #c2bdb2;
  font-family: "SFPro_regular";
}

@media (max-width: 1024px) {
  .Rule_rule__dGgPV {
    padding-top: 0;
    max-height: unset;
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Rule/Rule.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;AADJ;AAKE;ECkBA,eAAA;EACA,gBAAA;EACA,kBAAA;EDjBE,cAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,4BAAA;AAHJ;;AAOA;EACE;IACE,cAAA;IACA,iBAAA;IACA,YAAA;EAJF;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.rule {\n  padding-top: 20px;\n  position: relative;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-height: 180px;\n  height: 100%;\n  \n  .img {\n    display: flex;\n    justify-content: center;\n    \n  }\n\n  .title {\n    @include subtitle4m;\n\n    color: #ffffff;\n    margin-top: 20px;\n    margin-bottom: 16px;\n  }\n\n  .txt {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 131%;\n    text-align: center;\n    color: #c2bdb2;\n    font-family: \"SFPro_regular\";\n  }\n}\n\n@media (max-width: 1024px) {\n  .rule {\n    padding-top: 0;\n    max-height: unset;\n    height: 100%;\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rule": `Rule_rule__dGgPV`,
	"img": `Rule_img__VL+9D`,
	"title": `Rule_title__mPmJN`,
	"txt": `Rule_txt__ZjHwb`
};
export default ___CSS_LOADER_EXPORT___;
